import React from 'react';
import { ChevronRightIcon, ListIcon } from 'lucide-react';
const tocItems = [{
  index: 0,
  label: 'Policy 1 — Range Safety Policy'
}, {
  index: 1,
  label: 'Policy 2 — Guest Policy'
}, {
  index: 2,
  label: 'Policy 3 — Membership Policy'
}, {
  index: 3,
  label: 'Policy 4 — Key / Access Card Policy'
}, {
  index: 4,
  label: 'Policy 5 — Clubhouse Rental Policy'
}, {
  index: 5,
  label: 'Policy 6 — Alcohol Policy'
}, {
  index: 6,
  label: 'Policy 7 — Grievance / Complaint Policy'
}, {
  index: 7,
  label: 'Policy 8 — Property and Equipment Policy'
}, {
  index: 8,
  label: 'Policy 9 — Financial Policy'
}, {
  index: 9,
  label: 'Policy 10 — Social Media Policy'
}, {
  index: 10,
  label: 'Policy 11 — Conflict of Interest Policy'
}, {
  index: 11,
  label: 'Policy 12 — Election Policy'
}];
export function TableOfContents() {
  const handleSelect = (index: number) => {
    window.dispatchEvent(new CustomEvent('policy-select', {
      detail: index
    }));
  };
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2556">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2557">
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2558">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-2559">
            <ListIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-2560" />
            <h2 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-2561">
              Table of Contents
            </h2>
          </div>
          <div className="p-5" data-id="element-2562">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-2563">
              {tocItems.map(item => <a key={item.index} href={`#policy-${item.index}`} onClick={() => handleSelect(item.index)} className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors hover:bg-gray-50" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2564">
                  <ChevronRightIcon size={14} style={{
                color: '#c8a84b'
              }} data-id="element-2565" />
                  {item.label}
                </a>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}